<!--
 * @Descripttion: 轮播图-公告
 * @Author: chenjinsheng
 * @Date: 2021-08-10 16:19:41
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-26 14:49:42
-->
<template>
    <div v-if="checkPermission('UDWWB_BANNER_ADV')" class="swiper-tip-container">
        <el-carousel :interval="5000" arrow="never">
            <el-carousel-item v-for="(item, index) in records" :key="index">
                <div
                    class="img-wrap"
                    :style="{ 'background-image': 'url(' + item.image + ')' }"
                    :class="{ 'link-show': !['', undefined, NaN, null].includes(item.url) || item.advertType === 2 }"
                    @click="openWin(item)"
                ></div>
                <span v-show="item.showTitle" class="ad-title"> {{ item.title }}</span>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
import { advList } from "@/api";
export default {
    data() {
        return {
            defaultImg:
                "http://nhfcloms-admin-dev.oss-cn-beijing.aliyuncs.com/dwwb/portal/project/1637229228766/%E7%BC%96%E7%BB%84%203%402x.png",
            params: {
                current: 1,
                size: 20,
                isLate: 0,
                adPositionId: 1,
            },
            records: [],
        };
    },
    mounted() {
        this.getBannerList();
    },
    methods: {
        async getBannerList() {
            try {
                const { body, code, message } = await advList({
                    ...this.params,
                });
                if (code === "0000") {
                    const bannerList = body ? body.records.slice(0, 5) : [];
                    if (bannerList.length === 0) {
                        bannerList.push({
                            image: this.defaultImg,
                        });
                    }
                    this.records = bannerList;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
        },

        openWin(item) {
            if (item.advertType === 2) {
                this.$router.push(`/work-portal/adv-details?id=${item.id}&source=dwwb`);
            } else {
                if (item.url) {
                    window.open(item.url);
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@mixin space-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.swiper-tip-container {
    position: relative;
    width: 100%;
    margin-bottom: 20px;
    z-index: 1;
    /deep/ .el-carousel__container {
        width: 100%;
        height: 115px;
        background: linear-gradient(270deg, #002306 0%, #0a2d10 58%, #002306 100%);
    }
    /deep/ .el-carousel {
        position: relative;
    }
    /deep/ ul.el-carousel__indicators--horizontal {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        position: absolute !important;
        bottom: 0 !important;
        right: 0 !important;
        transform: none !important;
        padding-right: 5%;
    }
    // 未选中状态
    /deep/ .el-carousel__indicator .el-carousel__button {
        background: #959595;
        border-radius: 50%;
        height: 12px;
        width: 12px;
    }

    // 选中状态
    /deep/ .el-carousel__indicator.is-active .el-carousel__button {
        background: white;
    }
    .el-carousel__item {
        .img-wrap {
            width: 100%;
            height: 100%;
            background-position: center center;
            background-attachment: scroll;
            background-size: cover;
            -webkit-background-size: cover;
            background-repeat: no-repeat;
        }
        .link-show {
            cursor: pointer;
        }
        // img {
        //     width: 100%;
        //     height: 100%;
        //     object-fit: cover;
        // }
        &:nth-child(2n) {
            background-color: #99a9bf;
        }
        &:nth-child(2n + 1) {
            background-color: #d3dce6;
        }
        .ad-title {
            display: inline-block;
            height: 38px;
            line-height: 38px;
            position: absolute;
            bottom: 0px;
            right: 20%;
            font-size: 18px;
            color: #fff;
            font-weight: bold;
            font-family: "黑体";
        }
    }
    .tip {
        @include space-between;
        width: 96%;
        margin: 20px 2%;
        padding: 10px 20px;
        border-radius: 8px;
        background: #fff;
        opacity: 0.8;
        cursor: pointer;
        .about {
            font-size: 14px;
            color: #333333;
        }
        .more {
            font-size: 14px;
            color: #666666;
            cursor: pointer;
        }
    }
}
</style>
